import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { SsoProvider } from '~shared/models/general/sso.model';
import { BaseApiService } from '../base.api-service';

const SSO_PATH = '/auth/sso';

@Injectable({
  providedIn: 'root',
})
export class SsoApiService extends BaseApiService {
  /** Fournisseurs proposés pour une adresse e-mail (liste vide si aucun). */
  discover(email: string): Observable<SsoProvider[]> {
    return this.http.post<SsoProvider[]>(
      environment.apiBasePaths.general + SSO_PATH + '/discover',
      { email }
    );
  }

  /** URL du fournisseur vers laquelle rediriger le navigateur. */
  start(providerId: number): Observable<{ authorization_url: string }> {
    return this.http.post<{ authorization_url: string }>(
      environment.apiBasePaths.general + `${SSO_PATH}/${providerId}/start`,
      { locale: this.currentLang }
    );
  }

  /** Échange le code reçu sur /auth/callback contre le jeton de la plateforme. */
  callback(code: string, state: string): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(
      environment.apiBasePaths.general + SSO_PATH + '/callback',
      { code, state }
    );
  }
}
